import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import 'mdui/components/button.js';
import 'mdui/components/icon.js';
import './style.css';

const MDUIButton = React.forwardRef(
  (
    {
      onClick,
      icon,
      endIcon,
      variant = 'filled',
      style,
      children,
      to,
      ...props
    },
    ref
  ) => {
    const buttonRef = useRef(null);
    // If variant is 'outlined', set border color to primary
    return (
      <mdui-button
        ref={el => {
          buttonRef.current = el;
          if (typeof ref === 'function') ref(el);
          else if (ref) {
            const refCurrent = ref;
            refCurrent.current = el;
          }
        }}
        href={to}
        target="_blank"
        className={`mdui-button mdui-button-${variant}`}
        style={style}
        onClick={event => {
          event.stopPropagation(); // Prevents double execution
          if (onClick) {
            onClick(event);
          }
        }}
        variant={variant}
        {...props}
      >
        <mdui-icon slot="icon" name={icon} />
        <mdui-icon slot="end-icon" name={endIcon} />
        {children}
      </mdui-button>
    );
  }
);

MDUIButton.propTypes = {
  onClick: PropTypes.func,
  icon: PropTypes.string,
  endIcon: PropTypes.string,
  to: PropTypes.string,
  variant: PropTypes.oneOf([
    'filled',
    'outlined',
    'raised',
    'fab',
    'icon',
    'text'
  ]),
  style: PropTypes.object,
  children: PropTypes.node
};

export default MDUIButton;
